import { Locale, toCountryFromLocale } from '@peloton/internationalize'; // eslint-disable-next-line no-restricted-imports

import { toCurrencySymbol } from '@peloton/internationalize/models/currencySymbol';
export var toPricing = function toPricing(countryToPriceMap, locale) {
  var country = toCountryFromLocale(locale);

  if (locale === Locale.GermanGermany) {
    return "".concat(countryToPriceMap[country].toLocaleString(locale), " ").concat(toCurrencySymbol(locale));
  }

  return "".concat(toCurrencySymbol(locale)).concat(countryToPriceMap[country].toLocaleString(locale));
};